module.exports = __webpack_public_path__ + "assets/img/page3-design-side-nav-expanded-2-db2e6f86.png";